import { configureStore } from '@reduxjs/toolkit'
import sheetsSlice from './slices/sheetsSlice/sheetsSlice'
import usersSlice from './slices/userSlice'
import profile from './slices/profileSlice/profileSlice'
import noticeSlice from './slices/noticeSlice/noticeSlice'
import noticeInfoSlice from './slices/noticeInfoSlice/noticeInfoSlice'
import noticeInfoAdminSlice from './slices/noticeInfoAdminSlice/noticeInfoAdminSlice'
import noticeStudentSlice from './slices/noticeStudentSlice/noticeStudentSlice'

export const store = configureStore({
  reducer: {
		usersR: usersSlice,
		sheets: sheetsSlice,
    profile: profile,
    notice: noticeSlice,
    noticeInfo: noticeInfoSlice,
    noticeInfoAdmin: noticeInfoAdminSlice,
    noticeStudent: noticeStudentSlice,
	},
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
